import { Actions } from "vuex-smart-module";
import axios from "@/web_client/axios_config";

import FeaturesState from "./state";
import FeaturesMutations from "./mutations";
import FeaturesGetters from "./getters";
import Urls from "@/web_client/urls";
import { MutationTypes } from "../mutations-types";
import { IMobilePlatformUpdate, IMobilePlatformCreate } from "./models";

const featuresUrl = Urls.featuresUrls;

export default class FeaturesActions extends Actions<
  FeaturesState,
  FeaturesGetters,
  FeaturesMutations,
  FeaturesActions
> {
  //Carga de datos desde el backend
  getFixedPlatforms() {
    axios.get(featuresUrl.fixedPlatforms).then((response) => {
      this.commit(MutationTypes.SET_FIXED_PLATFORMS, response.data.features);
    });
  }
  getMobilePlatforms() {
    axios.get(featuresUrl.mobilePlatforms).then((response) => {
      this.commit(MutationTypes.SET_MOBILE_PLATFORMS, response.data.features);
    });
  }
  getLinealPlatforms() {
    axios.get(featuresUrl.linealPlatforms).then((resp) => {
      this.commit(MutationTypes.SET_LINEAL_PLATFORMS, resp.data.features);
    });
  }
  getPipelines() {
    axios.get(featuresUrl.ducts).then((resp) => {
      this.commit(MutationTypes.SET_PIPELINES, resp.data.features);
    });
  }
  getChannels() {
    axios.get(featuresUrl.channels).then((resp) => {
      this.commit(MutationTypes.SET_CHANNELS, resp.data.features);
    });
  }
  getChartAchare() {
    axios.get(featuresUrl.chartAnchorages).then((resp) => {
      this.commit(MutationTypes.SET_CHART_ACHARE, resp.data.features);
    });
  }
  //CRUD de plataformas móviles
  createMobilePlatform(datos: IMobilePlatformCreate) {
    axios
      .post(featuresUrl.mobilePlatforms, datos)
      .then(() => {
        this.dispatch("getMobilePlatforms");
      })
      .catch((err) => {
        console.log(err);
      });
  }
  deleteMobilePlatform(id: number) {
    axios
      .delete(featuresUrl.mobilePlatforms + `${id}/`)
      .then(() => this.dispatch("getMobilePlatforms"));
  }
  updateMobilePlatform(platform: IMobilePlatformUpdate) {
    axios
      .patch(featuresUrl.mobilePlatforms + `${platform.id}/`, platform)
      .then(() => this.dispatch("getMobilePlatforms"));
  }
  //Visualizacion de etiquetas
  /* changePlatformsTag() {
    this.commit(MutationTypes.CHANGE_PLATFORM_TAG);
  } */
}
